
<form 
  novalidate
  [formGroup]="form"
  (ngSubmit)="submit()">
  <div>
    <label
      for="inputTitleId"
      class="form-label"
      >Title</label
    >
  </div>
  <div class="mb-3">
    <input
      type="text"
      class="form-control"
      id="inputTitleId"
      formControlName="title"
      [ngClass]="{
        'is-valid': form.get('title')?.valid && form.get('title')?.touched,
        'is-invalid': form.get('title')?.invalid && form.get('title')?.touched
      }" />
    <div
      *ngIf="!form.get('title')?.valid && form.get('title')?.touched"
      class="invalid-feedback">
      Title is required.
    </div>
  </div>

  <div>
    <label
      for="inputTextId"
      class="form-label"
      >Text</label
    >
  </div>
  <div class="mb-3">
    <input
      type="text"
      class="form-control"
      id="inputTextId"
      formControlName="text"
      [ngClass]="{
        'is-valid': form.get('text')?.valid && form.get('text')?.touched,
        'is-invalid': form.get('text')?.invalid && form.get('text')?.touched
      }" />
    <div
      *ngIf="!form.get('text')?.valid && form.get('text')?.touched"
      class="invalid-feedback">
      Text is required.
    </div>
  </div>

  <button
    type="submit"
    class="btn btn-lg btn-primary"
    [disabled]="form.invalid">
    Submit
  </button>
</form>
